import { useEffect, useState } from "react";
import { _AdquisitionContract, _single } from "../../../../core/services/dataBean/EntityCatalog";
import useDataBean from "../../../../core/services/dataBean/useDataBean";
import { PrintJson } from "../../../theme/Component/PrintJson"
import { BasicTable, MASK_MONEY, MASK_NUMBER } from "../../../theme/Component/BasicTable";
import { ListMenu } from "../../../theme/Component/ListMenu";
import useModal, { MODAL_XL } from "../../../theme/Component/hooks/useModal";
import { Modal } from "../../../theme/Component/Modal";
import { VisorDocumentFactory } from "../../../documents/VisorDocumentFactory";

interface Props{
    nameProp:string;
    props:any;    
}
export const ResumeContract =({nameProp,props}:Props)=>{

    
    const _contract = useDataBean(_AdquisitionContract);
    const {lista,setLista,bean,setBean} = _contract;
     const [document,setDocument] = useState<any>({});
     const modalDocumento = useModal("Documento",MODAL_XL);

    useEffect(()=>{
        let filter = {};
        filter[nameProp] = props[nameProp];
        _contract.instance.getResumenPayment(_single.getCurrenYear(),filter,null).then(
            (resp:any)=>{
                setLista(resp);
            }
        )
    },[props])

        const head = [
        {title:'ID',property:'IDAdquisitionContract',visible:false,mask:MASK_NUMBER},
        {title:'Item PAA',property:'IDAdquisitionItem',visible:false,mask:MASK_NUMBER},
        {title:'No. Contrato',property:'InternalCode',visible:true},
        {title:'Objecto',property:'Description',visible:true},
        {title:'Nit',property:'Nit',visible:true,mask:MASK_NUMBER},
        {title:'Proveedor',property:'EntityName',visible:true},
        // {title:'CDP',property:'CDPDocument',visible:true},
        {title:'RP',property:'RDDocument',visible:true},
        {title:'OB',property:'OBDocument',visible:true},  
        {title:'Fecha RP',property:'DocumentDate',visible:true},
        {title:'Fecha OB',property:'DocumentDateOB',visible:true},
        // {title:'Contrato Valor',property:'ContractAmount',visible:true,mask:MASK_MONEY},  
        // {title:'CDP Valor',property:'CDPValue',visible:true,mask:MASK_MONEY},  
        {title:'RP Valor',property:'RPValue',visible:true,mask:MASK_MONEY},  
        {title:'OB Valor',property:'OBValue',visible:true,mask:MASK_MONEY},  
        // {title:'CE Valor',property:'CEValue',visible:true,mask:MASK_MONEY},  
    ]

    const listaBotones =()=>{
        const botones = [
            // {titulo:'Ver CDP',icono:'ri-file-add-line',visible:true,evento:verCDP},
            {titulo:'Ver RP',icono:'ri-file-add-line',visible:true,evento:verRP},
            {titulo:'Ver OB',icono:'ri-file-add-line',visible:true,evento:verOB},
            

        ]
        return(
            <ListMenu listaBotones={botones}/>
        )
    }

    const getYearByDate=(date:Date)=>{
        let fecha= new Date(date);
        return fecha.getFullYear();
    }

    const verCDP=()=>{
        setDocument({Mnemonic:bean.CDPMnemonic,Consecutive:bean.CDPConsecutive, Year:getYearByDate(bean.DocumentDate)});
        modalDocumento.open();
    }
    const verRP=()=>{
        setDocument({Mnemonic:bean.RPMnemonic,Consecutive:bean.RPConsecutive, Year:getYearByDate(bean.DocumentDate)});
        modalDocumento.open();
    }
    const verOB=()=>{
        setDocument({Mnemonic:bean.OBMnemonic,Consecutive:bean.OBConsecutive, Year:getYearByDate(bean.DocumentDateOB)});
        modalDocumento.open();
    }
    
    return(
        <div className="row">
            <div className="col-md-12">
                <BasicTable head={head} body={lista} rowSet={setBean} listButtons={listaBotones()} ></BasicTable>
                {/* <PrintJson json={document}/> */}
                <Modal modal={modalDocumento.modal} updateModal={modalDocumento.setModal}>
                    <VisorDocumentFactory  Consecutive={document.Consecutive} Mnemonic={document.Mnemonic} Year={document.Year}/>
                </Modal>
            </div>
        </div>
    )
}